export default __webpack_public_path__ + "static/media/103-marshall-island.f52a9bf5.svg";